import * as React from 'react'

import FormHelperText from '@mui/material/FormHelperText'
import Stack from '@mui/material/Stack'

import { CONTACT_GROUP_ERROR_KEY, CONTACT_GROUP_FIELDS } from '../typings'
import { RequiredTextField } from './RequiredTextField'
import { useGroupError } from './hooks/useGroupError'
import { useGroupRequired } from './hooks/useGroupRequired'

/**
 * Phone number and email address inputs; either one satisfies the group. A group error outlines
 * both inputs and shows its message once underneath.
 */
export function PhoneOrEmailFields() {
  const { invalid, message } = useGroupError(
    CONTACT_GROUP_ERROR_KEY,
    CONTACT_GROUP_FIELDS,
  )

  const required = useGroupRequired(CONTACT_GROUP_FIELDS)

  return (
    <Stack spacing={2}>
      <RequiredTextField
        name="phoneNumber"
        label="Phone Number"
        testId="auto-review-phone-number"
        required={required}
        invalid={invalid}
      />
      <RequiredTextField
        name="emailAddress"
        label="Email Address"
        testId="auto-review-email-address"
        required={required}
        invalid={invalid}
      />
      {message && <FormHelperText error>{message}</FormHelperText>}
    </Stack>
  )
}
PhoneOrEmailFields.displayName = 'PhoneOrEmailFields'
